import { formatCompactINR, formatINR, fromMinor } from '@fpc/shared';

export { formatINR, formatCompactINR, fromMinor };

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** "3 days ago" / "in 5 days" — used for due dates and approval ageing. */
export function relativeDays(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? new Date(value) : value;
  const days = Math.round((date.getTime() - Date.now()) / 86_400_000);
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days === -1) return 'yesterday';
  return days > 0 ? `in ${days} days` : `${Math.abs(days)} days ago`;
}

export function isOverdue(value: string | Date | null | undefined): boolean {
  if (!value) return false;
  const date = typeof value === 'string' ? new Date(value) : value;
  return date.getTime() < Date.now();
}

/** SCREAMING_SNAKE → Title Case, for statuses shown to users. */
export function humanize(value: string | null | undefined): string {
  if (!value) return '—';
  return value
    .split('_')
    .map((part) =>
      ACRONYMS.has(part.toUpperCase())
        ? part.toUpperCase()
        : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase(),
    )
    .join(' ');
}

/** Kept in capitals, as finance writes them: "GSTIN Same As Company", not "Gstin …". */
const ACRONYMS = new Set([
  'GSTIN',
  'GST',
  'PAN',
  'TDS',
  'IFSC',
  'PO',
  'CFO',
  'UTR',
  'NEFT',
  'RTGS',
]);

/** Parses a rupee input field into integer paise. */
export function rupeesToMinor(value: string): number | null {
  const cleaned = value.replace(/[₹,\s]/g, '');
  if (!cleaned || !/^\d*\.?\d{0,2}$/.test(cleaned)) return null;
  return Math.round(Number(cleaned) * 100);
}
